import React, {useEffect} from 'react';
import personal from "../../common/section-questions/applicant/personal";
import employment from "../../common/section-questions/applicant/employment";
import income from "../../common/section-questions/applicant/income";
import properties from "../../common/section-questions/applicant/properties";
import assets from "../../common/section-questions/applicant/assets";
import debts from "../../common/section-questions/applicant/debts";
import needs from "../../common/section-questions/mortgage/needs";
import existing from "../../common/section-questions/mortgage/existing";
import property from "../../common/section-questions/mortgage/property";
import {DataStore} from "@aws-amplify/datastore";
import {modelClasses} from "../../common";
import {getModel, sectionNow} from "../../common/section-questions/sections";
import {
    UserApplicant,
    UserApplicantFinancial,
    UserMortgage, UserMortgageProgress,
    UserMortgageProperty,
    UserMortgageUploads
} from "../../models";
import {capitaliseFirst} from "../../common/section-questions/applicant/__strings";
import setup from "../../common/section-questions/mortgage/setup";
import deposit from "../../common/section-questions/mortgage/deposit";
import uploads from "../../common/section-questions/mortgage/uploads";
export const SectionsContext = React.createContext({})


function SectionsProvider(props) {
    function applicantSections(myProps) {
        return [
            personal(myProps),
            employment(myProps),
            income(myProps),
            properties(myProps),
            assets(myProps),
            debts(myProps)
        ]
    }
    let sectionProps = {mortgage: props.mortgage}
    let sections = {
        apply: [],
        uploads: [],
        tasks: []
    }

    /* APPLICANT SECTIONS */
    if ([true,false].includes(props.mortgage.twoApplicants) && !!props.mortgage?.mortgageType) {
        sections.apply = [...sections.apply, ...applicantSections({...sectionProps, applicant: 1})]
        if (props.mortgage.twoApplicants) {
            sections.apply = [...sections.apply, ...applicantSections({...sectionProps, applicant: 2})]
        }
    }

    /* MORTGAGE SECTIONS */
    sections.apply = [...sections.apply, needs(sectionProps), property({...sectionProps, applicant: false})]
    if (props.mortgage.mortgageType === 'REFINANCE') {
        sections.apply = [...sections.apply, existing({...sectionProps, applicant: false})]
    }
    else{
        sections.apply = [...sections.apply, deposit({...sectionProps, applicant: false})]
    }

    sections.apply = prepareQuestionSections(sections.apply,"APPLY", "QUESTIONS")
    sections.apply = [...sections.apply, ...prepareQuestionSections([setup(sectionProps)], "APPLY", "QUESTIONS")]

    console.log(sections)

    /* UPLOAD SECTIONS */
    let u = uploads({mortgage:props.mortgage})
    sections.uploads = [...sections.uploads, ...u.uploads]





    /* TASKS SECTIONS */



    const doAnswerForSideEffects = (section, question, value)=>{
        // Populate app1 home address if this is the mortgaged property and the app1 home address is empty
        if (!section.applicant && section.root === 'property' && question.name === 'residingHere' && value===true){
            if (section.props.mortgage.mortgageType === 'REFINANCE' && !section.props.mortgage.property.address){
                const updated = UserMortgageProperty.copyOf(props.mortgage.property,item=>{
                    item.address = props.mortgage.applicant1.personal.addressCurrent
                })
                DataStore.save(updated)
            }
        }
        return {section, question, value}
    }
    const answerSectionQuestion = async function (origSection, origQuestion, origValue) {
        const {section,question,value} = doAnswerForSideEffects(origSection,origQuestion,origValue)
        switch (question.model){
            // this is a hack because datastore keeps reporting a invalid source otherwise
            case 'applicant':
                let id = section.applicant === 2 ? props.mortgage.applicant2ID:props.mortgage.applicant1ID
                let app = await DataStore.query(UserApplicant, id)
                DataStore.save(UserApplicant.copyOf(app, mutator=>{
                    mutator[question.name] = value
                }))
                break;
            case 'mortgage':
                let mort = await DataStore.query(UserMortgage, props.mortgage.id)
                DataStore.save(UserMortgage.copyOf(mort, mutator=>{
                    mutator[question.name] = value
                }))
                break;
            default:
                let model = modelClasses[question.model]
                let original = getModel(section, question.model, props.mortgage)
                let copy = model.copyOf(original, updated => updated[question.name] = value)
                DataStore.save(copy);
        }
    }
    const addRepeatingInstance = async function (section) {
        const modelName = section.models[0]
        const appAttr = 'applicant' + section.applicant
        const attributes = {
            applicant: section.props.mortgage[appAttr],
            applicantID: section.props.mortgage[appAttr].id,
            observeMID: section.props.mortgage.id
        }
        const newInstance = await DataStore.save(new modelClasses[modelName](attributes))
        return newInstance.id
    }
    const removeRepeatingInstance = async function (section) {
        const model = getModel(section,section.models[0])
        DataStore.delete(model);
    }

    const setHasFinancial = async function (section){
        const key = `has${capitaliseFirst(section.root)}`
        const appKey = `applicant${section.applicant}`
    }
    function prepareQuestionSections(sections, stage, type) {
        //adds additional attribs to section
       // console.log('preparing sections')
        return sections.map(section => {
            let root = section.name
            const parts = root.split('-')
            let applicant = false;
            if (!isNaN(parts[parts.length - 1])) {
                applicant = parseInt(parts.pop())
                root = parts.join('')
            }
            const usedModels = []
            section.questions.forEach(question => {
                if (!usedModels.includes(question.model)) {
                    usedModels.push(question.model)
                }
            })

            const newSection = {
                ...section,
                ...{
                    stage: stage,
                    root: root,
                    applicant: applicant,
                    models: usedModels,
                    link: root,
                    type: type
                }
            }
            return newSection
        }).map(section=>{
            section.progress = sectionNow(section)
            return section
        })
    }
    //console.log(sections)
    const createUploadModels = async function (section, files) {
        const newModels = await Promise.all(files.map(file => {
            const attributes = {
                contentType: file.type,
                fileName: file.name.substr(0, file.name.lastIndexOf(".")),
                fileSize: file.size,
                stage: section.stage,
                section: section.name,
                mortgageID: section.props.mortgage.id,
                observeMID: section.props.mortgage.id,
                status: 'UPLOADING',
            }
            if (section?.index) {
                attributes.index = section.index
            }
            return DataStore.save(new UserMortgageUploads(attributes))
        }))
        return newModels
        //add the file onto the model - will be removed after upload is complete
        // const alteredModels = newModels.map((model,index)=> {
        //     return UserMortgageUploads.copyOf(model, updated => {
        //         updated.file = files[index]
        //     })
        // })
        //mortgageContext.addUploads(alteredModels)
        //mortgageContext.updateMortgage({...section,props:{mortgage:mortgageContext.mortgage}}, alteredModels, "uploads")
    }
    useEffect(()=>{
        // ENSURE Progress Rows Exist
        let promises = []
        if (sections){
            ['apply','uploads','tasks'].forEach(item=>{
                sections[item].forEach(section=>{
                    let found = props.mortgage.progress.find(i=>{
                        if (i.sectionName === section.name && i.applicationStage === section.stage){
                            if (section?.index){
                                return i.sectionIndex === section.index
                            }
                            return true
                        }
                    })
                    if (!found){
                        let init = {
                            applicationStage: section.stage,
                            sectionType: section.type,
                            sectionName: section.name,
                            percent:0,
                            mortgageID: props.mortgage.id,
                        }
                        if (section?.index){
                            init.sectionIndex = section.index

                        }
                        promises.push(DataStore.save(
                            new UserMortgageProgress(init)
                        ));
                    }
                })
            })
            Promise.allSettled(promises)
        }
    },[])
    return (
        <>
            {props.mortgage && (<SectionsContext.Provider value={{
                sections: sections,
                answer: answerSectionQuestion,
                addRepeater: addRepeatingInstance,
                removeRepeater: removeRepeatingInstance,
                save:{
                    financial: (orig, mutations)=>{
                        DataStore.save(UserApplicantFinancial.copyOf(orig,mutator=>{
                            Object.keys(mutations).forEach(key=>{
                                mutator[key] = mutations[key]
                            })
                        }))
                    },
                    upload: (orig, mutations)=>{
                        DataStore.save(UserMortgageUploads.copyOf(orig,mutator=>{
                            Object.keys(mutations).forEach(key=>{
                                mutator[key] = mutations[key]
                            })
                        }))
                    },
                    files: createUploadModels,
                },
                delete:{
                    upload: async (id)=>{
                        let m = await DataStore.query(UserMortgageUploads,id)
                        DataStore.delete(m);
                    }
                }
            }}>
                {props.children}
            </SectionsContext.Provider>)
            }
        </>
    )
}

export default SectionsProvider;